import { IPixStatusRepository } from 'modules/customer/domain/repositories';

export class CheckPixStatusUseCase {
  constructor(private pixStatusRepository: IPixStatusRepository) {}

  public async execute(id: number) {
    return this.pixStatusRepository.findById(id);
  }
}
